import { render, staticRenderFns } from "./KioskTablePicker.vue?vue&type=template&id=1b9f5a4b&scoped=true"
import script from "./KioskTablePicker.vue?vue&type=script&lang=js"
export * from "./KioskTablePicker.vue?vue&type=script&lang=js"
import style0 from "./KioskTablePicker.vue?vue&type=style&index=0&id=1b9f5a4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9f5a4b",
  null
  
)

export default component.exports